import React from 'react';
import classes from './EditReplicationFlow.module.scss';
import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';

interface ConfigProps {
  config: { [key: string]: any };
  height: number;
}

const loadableMonacoEditorOptions = {
  readOnly: true,
  minimap: { enabled: false },
};

export const Config = (props: ConfigProps) => {
  const { height } = props;
  return (
    <div className={classes.editorContainer}>
      <LoadableMonacoEditor
        width="100%"
        height={height}
        value={JSON.stringify(props.config, null, 4)}
        language={'json'}
        options={loadableMonacoEditorOptions}
      />
    </div>
  );
};
